import DealerSettings from '../../../../appmodules/users-settings/dealer-settings';
import UserSettings from '../../../../appmodules/users-settings';

export const userSettingList = [
    {
        path: '/settings/dealer',
        name: 'Dealer Location',
        component: DealerSettings,
    },
];

export const settings = [
    {
        path: '/settings',
        name: 'SETTINGS',
        component: UserSettings,
        childRoute: [
            ...userSettingList,
        ],
    },
];
